export const environment = {
  production: false,
  bucketUrlImages: 'https://video-demo-test.akiru.se/images/',
  bucketUrlVideos: 'https://video-demo-test.akiru.se/videos/'
}
